import { useEffect, useMemo, useState } from "react";

import { useSelector } from "react-redux";

import {
  formatIsoDate,
  renderStatus,
  formatName,
} from "../../utils/generalUtils";

import GeneratePdf from "../../generatePdf/GeneratePdf";

import SpectatorTable from "../../components/Table/SpectatorTable";
import useSpectateTrlService from "../../services/Spectator/spectateTrlService";
import usePositionService from "../../services/PositionAdmin/positionService";
import { Input, Select, Space } from "antd";

const { Search } = Input;

const AllTrl = () => {
  const { getTrlFromAppId, trlLoading, trlResponse } = useSpectateTrlService();
  const { getAllApprovers, approverResponse } = usePositionService();
  const { adminAllTrlPopup } = useSelector((state) => state.generalSlice);

  console.log(trlResponse);

  const mappedApprovers = useMemo(() => {
    return (approverResponse?.data || []).map((item) => ({
      value: item?.id,
      label: item?.position_name,
    }));
  }, [approverResponse]);

  const [selectedPos, setSelectedPos] = useState();
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    getAllApprovers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedPos == null && mappedApprovers.length > 0) {
      const first = mappedApprovers[0].value;
      setSelectedPos(first);
      getTrlFromAppId(first);
    }
  }, [mappedApprovers, selectedPos, getTrlFromAppId]);

  const handlePosSelect = (posId) => {
    setSelectedPos(posId);
    getTrlFromAppId(posId);
  };

  const allMappedData =
    trlResponse?.data?.map((item, index) => ({
      key: index + 1,
      submitter: `${item?.submission?.submitter?.last_name || ""}, ${
        item?.submission?.submitter?.first_name || ""
      }`.trim(),
      formattedName: formatName(
        item?.submission?.submitter?.first_name,
        item?.submission?.submitter?.middle_name,
        item?.submission?.submitter?.last_name,
        "lfmcut"
      ),
      approver_name: `${item?.approver?.last_name || ""}, ${
        item?.approver?.first_name || ""
      }`.trim(),
      formattedApproverName: formatName(
        item?.approver?.first_name,
        item?.approver?.middle_name,
        item?.approver?.last_name,
        "lfmcut"
      ),
      ...item?.submission?.travel_request_local,
      date_submitted: item?.submission?.created_at
        ? formatIsoDate(item?.submission?.created_at)
        : null,
      submitter_position: item?.submission?.position?.position_name,
      remarks: item?.submission?.remarks || null,
      status: item?.status || "no data",
      submission_id: item?.submission?.id,
      approval_id: item?.id,
      approval_date: item?.approval_date,
    })) || [];

  const mappedData = searchValue
    ? allMappedData.filter((item) =>
        [item.submitter, item.approver_name, item.destination]
          .filter(Boolean)
          .some((val) => val.toLowerCase().includes(searchValue.toLowerCase()))
      )
    : allMappedData;

  const columns = [
    {
      title: "No.",
      dataIndex: "key", width: 60,
      rowScope: "row",
    },
    {
      title: "Submitter",
      dataIndex: "submitter",
      key: "submitter",
    },
    {
      title: "Approver",
      dataIndex: "approver_name",
      key: "approver_name",
    },
    {
      title: "Destination",
      dataIndex: "destination",
      key: "destination",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: renderStatus(
        ["pending"],
        ["approved"],
        ["disapproved", "denied"]
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, item) => {
        return (
          <GeneratePdf
            docuType="trl"
            contents={item}
            disabled={item?.status !== "approved"}
          />
        );
      },
    },
  ];

  const viewingDataConfig = [
    {
      //  NOTE: MAKE THE KEY TO 1 IN SENDING THE PROPS IF YOU WANT IT ACTIVE, 0 OTHERWISE
      key: 1,
      collapseName: "Required Details",
      collapseItems: [
        {
          key: 1,
          name: "name",
          label: "Requester",
        },
        {
          key: 2,
          name: "start_date",
          label: "Start Date",
        },
        {
          key: 3,
          name: "end_date",
          label: "End Date",
        },
        {
          key: 4,
          name: "destination",
          label: "Destination",
        },
        {
          key: 5,
          name: "purpose",
          label: "Purpose of Travel",
        },
      ],
    },
    {
      //  NOTE: MAKE THE KEY TO 1 IN SENDING THE PROPS IF YOU WANT IT ACTIVE, 0 OTHERWISE
      key: 1,
      collapseName: "Additional Details",
      collapseItems: [
        {
          key: 1,
          name: "expenses",
          label: "Estimated Expenses",
        },
        {
          key: 2,
          name: "funding_sourse",
          label: "Funding Source",
        },
        {
          key: 3,
          name: "local_travel_transportation",
          label: "Local Travel Transportation",
        },
        {
          key: 4,
          name: "entitlement",
          label: "Entitlement",
        },
      ],
    },
    {
      //  NOTE: MAKE THE KEY TO 1 IN SENDING THE PROPS IF YOU WANT IT ACTIVE, 0 OTHERWISE
      key: 1,
      collapseName: "Approver's Remarks",
      collapseItems: [
        {
          key: 1,
          name: "remarks",
          label: "Remarks",
        },
      ],
    },
  ];

  return (
    <>
      {trlLoading && "loading..."}
      {!trlLoading && (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <Space>
              <p>See submissions under: </p>
              <Select
                defaultValue={selectedPos}
                options={mappedApprovers}
                onChange={handlePosSelect}
              />
            </Space>
            <Search
              placeholder="Search submitter, approver, destination..."
              value={searchValue}
              size="large"
              allowClear
              enterButton
              onSearch={setSearchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              style={{ maxWidth: 400 }}
            />
          </div>
          <SpectatorTable
            tableColumn={columns}
            tableData={mappedData}
            popupSlice={adminAllTrlPopup}
            popupName="adminAllTrlPopup"
            docuType="Certificate of Service"
            viewingDataConfig={viewingDataConfig}
          />
        </>
      )}
    </>
  );
};

export default AllTrl;
